export interface SubtitleLayoutConfig {
  fontSizeScale: number;
  maxWidthPercent: number;
  bottomOffset: string;
  yOffset: number;
  textWidth: number;
  maxCjkCharsPerSegment: number;
  maxLatinCharsPerSegment: number;
}

export function resolveSubtitleLayout(
  aspectRatio: number,
  configuredFontSize = 18,
): SubtitleLayoutConfig {
  const isPortrait = aspectRatio < 1;
  const isSquare = Math.abs(aspectRatio - 1) < 0.1;
  const containerAspectRatio = 16 / 9;
  const fontScale = Math.max(0.7, configuredFontSize / 18);

  if (isPortrait) {
    const videoWidthPercent = (aspectRatio / containerAspectRatio) * 100;
    const portraitSafeAreaPercent = videoWidthPercent * 0.8;
    return {
      fontSizeScale: 1.15 * fontScale,
      maxWidthPercent: portraitSafeAreaPercent,
      bottomOffset: '22%',
      yOffset: 240,
      textWidth: 0.8,
      maxCjkCharsPerSegment: 14,
      maxLatinCharsPerSegment: 20,
    };
  }

  if (isSquare) {
    const videoWidthPercent = (aspectRatio / containerAspectRatio) * 100;
    return {
      fontSizeScale: 1.4 * fontScale,
      maxWidthPercent: Math.min(videoWidthPercent * 0.9, 90),
      bottomOffset: '2.25rem',
      yOffset: 100,
      textWidth: 0.9,
      maxCjkCharsPerSegment: 18,
      maxLatinCharsPerSegment: 30,
    };
  }

  return {
    fontSizeScale: 1.4 * fontScale,
    maxWidthPercent: 90,
    bottomOffset: '1.5rem',
    yOffset: 50,
    textWidth: 0.9,
    maxCjkCharsPerSegment: 16,
    maxLatinCharsPerSegment: 26,
  };
}
